import { useTheme } from 'styled-components';

export const LoanDecisionIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="1" y="1" width="18" height="18" rx="4" stroke={theme.iceBlue} strokeWidth="1.5" />
      <text
        x="10"
        y="14.5"
        textAnchor="middle"
        fill={theme.iceBlue}
        fontSize="13"
        fontWeight="600"
        fontFamily="Arial, sans-serif"
      >
        €
      </text>
    </svg>
  );
};
